import {
    Button,
    Card,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { getAllState, resetState } from "../../Redux/StateSlice/stateSlice";
import {
    contractorsReset,
    GetSingleContractor,
    UpdateContractorData,
} from "../../Redux/ContractorSlice/ContractorSlice";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { useParams } from "react-router-dom";

const EditContractor = () => {
    const dispatch = useDispatch();
    const { id } = useParams();

    const { contractor, isLoading, isSuccess, isError, errors } = useSelector(
        (state) => state.contractors
    );
    const SingleContractor = contractor?.data;
    const { states } = useSelector((state) => state.AllStates);

    const AllStates = states?.data?.states;

    // get all states
    useEffect(() => {
        const getStates = async () => {
            await dispatch(getAllState());
            await dispatch(resetState());
        };
        getStates();
    }, []);

    const [substates, setStates] = useState([]);

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setStates(typeof value === "string" ? value.split(",") : value);
    };

    const validationSchema = yup.object({
        // name: yup.required("Name Field Is Required").string("ter");
    });
    const formik = useFormik({
        initialValues: {
            name: "",
            address: "",
            status: "",
            expiry_date: "",
            entity: "",
            license: "",
            initial: "",
            states: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            await dispatch(
                UpdateContractorData({
                    ...values,
                    states: substates,
                    contractor_id: id,
                })
            );
            await dispatch(contractorsReset());
        },
    });
    useEffect(() => {
        if (SingleContractor) {
            formik.values.name = SingleContractor?.name || "";
            formik.values.address = SingleContractor?.address || "";
            formik.values.status = SingleContractor?.status || "";
            formik.values.expiry_date = SingleContractor?.expiry_date || ""
            formik.values.entity = SingleContractor?.entity || "";
            formik.values.license = SingleContractor?.license || "";
            formik.values.initial = SingleContractor?.initial || "";
            formik.values.states = SingleContractor?.states;
            const states = [];
            const pushToStates = (state_id) => {
                states.push(state_id);
                setStates([...states]);
            };
            SingleContractor?.states?.map((state) => {
                pushToStates(state.id)
            });
        }
    }, [SingleContractor]);

    useEffect(() => {
        if (isError) {
            if (errors) {
                Object.keys(errors).forEach((key) => {
                    let error = errors[key][0];
                    toast.error(error);
                });
            }
            const reset = async () => {
                await dispatch(contractorsReset());
            };
            reset();
        }
    }, [isError]);

    useEffect(() => {
        if (isSuccess) {
            toast.success("Contractor details have been modified successfully");

            const reset = async () => {
                await dispatch(contractorsReset());
            };
            reset();
        }
    }, [isSuccess]);

    useEffect(() => {
        const getContractor = async () => {
            await dispatch(GetSingleContractor(id));
            await dispatch(contractorsReset());
        };
        getContractor();
    }, []);

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <FormContainer>
                    <FormHeading> Edit Contractor </FormHeading>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container columns={12} spacing={3}>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="name"
                                    name="name"
                                    label="Name"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="address"
                                    name="address"
                                    label="Address"
                                    value={formik.values.address}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl fullWidth required={true}>
                                    <InputLabel id="demo-simple-select-label">
                                        State
                                    </InputLabel>
                                    <Select
                                        id="status"
                                        name="status"
                                        label="Status"
                                        value={formik.values.status || ""}
                                        onChange={formik.handleChange}
                                    >
                                        <MenuItem value="active">
                                            Active
                                        </MenuItem>
                                        <MenuItem value="inactive">
                                            Inactive
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="expiry_date"
                                    name="expiry_date"
                                    label="Expiry Date"
                                    type="date"
                                    value={formik.values.expiry_date}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="entity"
                                    name="entity"
                                    label="Entity"
                                    value={formik.values.entity}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="license"
                                    name="license"
                                    label="License"
                                    value={formik.values.license}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="initial"
                                    name="initial"
                                    label="Initial"
                                    value={formik.values.initial}
                                    onChange={formik.handleChange}
                                />
                            </Grid>

                            <Grid item mb={2} xs={12} md={6}>
                                <FormControl fullWidth required={true}>
                                    <InputLabel id="states-label">
                                        States
                                    </InputLabel>
                                    <Select
                                        labelId="states-label"
                                        id="states"
                                        multiple
                                        value={substates}
                                        onChange={handleChange}
                                        required={true}
                                        input={<OutlinedInput label="Name" />}
                                        // MenuProps={MenuProps}
                                    >
                                        {AllStates?.map((key, index) => (
                                            <MenuItem
                                                key={index}
                                                value={key?.id}
                                            >
                                                {key?.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <PrimaryButton fullWidth type="submit">
                            {isLoading ? "loading ... " : " Edit Contractor"}
                        </PrimaryButton>
                    </form>
                </FormContainer>
            )}
        </>
    );
};

const FormContainer = styled.div`
    padding: 1rem;
`;
export default EditContractor;
